import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=2fc3821c&scoped=true"
import script from "./PageError.vue?vue&type=script&lang=js"
export * from "./PageError.vue?vue&type=script&lang=js"
import style0 from "./PageError.vue?vue&type=style&index=0&id=2fc3821c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3821c",
  null
  
)

export default component.exports